export default __webpack_public_path__ + "static/media/img-slider-craft-2024-1.c1b81531.png";